export const MoodStateOptions = [
  // Emociones básicas y fundamentales
  { value: 'happy', label: '1) Alegría - Felicidad, gozo, satisfacción', emoji: '😊' },
  { value: 'sad', label: '2) Tristeza - Pena, melancolía, desánimo', emoji: '😢' },
  { value: 'angry', label: '3) Enojo - Ira, furia, irritación', emoji: '😠' },
  { value: 'fear', label: '4) Miedo - Temor, pánico, terror', emoji: '😨' },
  { value: 'surprised', label: '5) Sorpresa - Asombro, desconcierto', emoji: '😮' },
  { value: 'disgusted', label: '6) Asco - Repugnancia, aversión', emoji: '🤢' },
  // { value: 'excited', label: '27) Entusiasmo - Emoción, euforia, anticipación' },

  // Emociones sociales y autoconscientes
  { value: 'proud', label: '7) Orgullo - Satisfacción por logros propios o ajenos', emoji: '😎' },
  { value: 'ashamed', label: '8) Vergüenza - Humillado', emoji: '😰' },
  { value: 'guilty', label: '9) Culpa - Remordimiento, arrepentimiento', emoji: '😔' },
  { value: 'jealous', label: '10) Celos - Envidia, desconfianza', emoji: '😒' },
  { value: 'love', label: '11) Amor - Cariño, afecto, ternura', emoji: '❤️' },
  // { value: 'grateful', label: '12) Agradecimiento - Gratitud, aprecio' },
  { value: 'contempt', label: '30) Desprecio - Desdén, menosprecio', emoji: '🙃' },
  { value: 'comic', label: '32) Cómico - Divertido, gracioso', emoji: '😂' },
  { value: 'blushing', label: '33) Apenado - Sonrojado, avergonzado', emoji: '😳' },

  // Estados cognitivos y mentales
  // { value: 'neutral', label: '13) Neutral - Calma, imparcialidad' },
  { value: 'confused', label: '14) Confusión - Desorientación, perplejidad', emoji: '😕' },
  { value: 'curious', label: '15) Curiosidad - Interés, intriga, exploración', emoji: '🤔' },
  { value: 'bored', label: '16) Aburrimiento - Desinterés, tedio, apatía', emoji: '😑' },
  // { value: 'hopeful', label: '17) Esperanza - Optimismo, fe, expectativa positiva' },
  { value: 'frustrated', label: '18) Frustración - Decepción, impotencia', emoji: '😤' },
  { value: 'overwhelmed', label: '19) Abrumado - Agobio, exceso de carga', emoji: '😫' },
  // { value: 'lonely', label: '20) Soledad - Aislamiento, desamparo' },
  { value: 'focused', label: '21) Concentración - Enfoque, atención plena', emoji: '🤓' },
  { value: 'challenge', label: '28) Desafío - Reto, provocación, competitividad', emoji: '😏' },
  // { value: 'satisfied', label: '29) Satisfacción - Contentamiento, plenitud' },
  { value: 'serious', label: '31) Serenidad - Actitud seria', emoji: '😐' },

  // Estados corporales y fisiológicos
  { value: 'sleepy', label: '22) Cansancio - Somnolencia, agotamiento, fatiga', emoji: '😴' },
  // { value: 'energetic', label: '23) Energía - Vitalidad, vigor, dinamismo' },
  { value: 'horny', label: '24) Excitación sexual - Lujuria, deseo sexual', emoji: '😈' },
  { value: 'anxious', label: '25) Ansiedad - Nerviosismo, preocupación, inquietud', emoji: '😟' },
  { value: 'relaxed', label: '26) Relajación - Paz, serenidad, tranquilidad', emoji: '😌' },
];
